<template>
	<div class="ui ui--share">
		<ElementList :entries="shareButtons" />
	</div>
</template>

<script>
import { contentShareText } from '@/tools/nativeInterfaceFunctions';
import { mapStateNested } from '@/tools/helpers';
import { mapState } from 'vuex';
import { exhibitionTypes } from '@/types';

export default {
	props: {
		exhibitionID: String,
		articleID: String,
	},
	data() {
		return {
			shareButtons: [
				{
					name: 'app-share',
					title: this.$i18n.t('share'),
					click: () => {
						const cmsURL = /staging/.test(this.dataSourceURL)
							? 'https://staging.shoutrlabs.com/'
							: 'https://cms.shoutrlabs.com/';

						if (this.exhibitionID == exhibitionTypes.calendar) {
							// calendar entry shared
							contentShareText(
								`${cmsURL}share/${this.global.landingExhibit.exhibitionID}/calendar/${this.articleID}`
							);
						} else if (/^tour-[a-zA-Z0-9]*-list/.test(this.articleID)) {
							// tour share
							contentShareText(`${cmsURL}share/${this.exhibitionID}/tour/${this.tour.current.id}`);
						} else {
							// normal article
							contentShareText(`${cmsURL}share/${this.exhibitionID}/${this.articleID}`);
						}
					},
				},
			],
		};
	},
	computed: {
		...mapState(['dataSourceURL', 'tour']),
		...mapStateNested('dataSourceCFG', ['exhibitionMap', 'global']),
	},
};
</script>

<style lang="scss"></style>
